import React, { Component } from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import { connect } from 'react-redux';
import { toggleForgotPasswordModal } from 'store/modules/modals';
import { EnterEmailFormModal } from 'components/ForgotPassword';
import { sendForgotPasswordEmailAction } from 'store/modules/auth/actions';

import AlertMessage from 'components/AlertMessage';

class ForgotPasswordModal extends Component {
  state = {
    showAlert: false,
    alertText: '',
  };
  sendForgotPasswordEmail = async (
    values,
    setSubmitting,
    setErrors,
    resetForm,
  ) => {
    const { sendForgotPasswordEmailAction } = this.props;
    const body = {
      user: {
        email: values.email,
      },
    };
    const response = await sendForgotPasswordEmailAction(
      body,
      setSubmitting,
      setErrors,
    );
    if (response.status === 200) {
      this.setState({ showAlert: true });
      this.setState({ alertText: response.data.message });
      setTimeout(() => {
        this.setState({ showAlert: false });
        this.props.toggle();
      }, 4000);
    }
  };

  render() {
    const { isShown, toggle } = this.props;
    const { showAlert, alertText } = this.state;
    return (
      <Modal isOpen={isShown}>
        {showAlert && <AlertMessage text={alertText} />}
        <ModalHeader toggle={toggle}>
          <div className="h2-title">Forgot your password?</div>
          <div className="separator-line" />
          <div className="text">
            Enter your email address to reset your password. You may need to
            check your spam folder.
          </div>
          <p />
        </ModalHeader>
        <EnterEmailFormModal handleSubmit={this.sendForgotPasswordEmail} />
      </Modal>
    );
  }
}

const mapStateToProps = state => ({
  isShown: state.modals.forgotPasswordVisibility,
});

const mapDispatchToProps = {
  toggle: toggleForgotPasswordModal,
  sendForgotPasswordEmailAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ForgotPasswordModal);



// WEBPACK FOOTER //
// ./src/components/Modals/ForgotPasswordModal.js